import { render, staticRenderFns } from "./footer2.vue?vue&type=template&id=ed667900&scoped=true"
import script from "./footer2.vue?vue&type=script&lang=js"
export * from "./footer2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed667900",
  null
  
)

export default component.exports